import React from 'react';
import { Grid, Box } from '@mui/material';
import styles from './index.module.scss';
import { UserManagement } from 'components/UserManagement';

export const UserManagementPage = () => {
  return (
    <Box className={styles.dashboardContainer}>
      <Box>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <UserManagement />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};
